<template>
  <Report :product="product" :isDetailsVisible="showDetails">
    <template v-slot:top>
      <template v-if="showDetails">
        <h3 class="mb-4 mt-6 mb-md-8 mt-md-11">{{ $t('report.priceList') }}</h3>

        <div class="row card-row d-print-none">
          <div
            class="col-sm-6 col-md-6 col-lg-6 col-xl-4 card-wrapper"
            v-for="(subscription, index) in product.subscriptions"
            :key="index"
          >
            <div class="card">
              <span class="card-title">{{ $subscriptionTitle(subscription) }}</span>
              <span class="card-subtitle">{{ $price(subscription.price) }}</span>
              <span class="card-subtext text-center">
                ({{ tc('report.subscription.period.shortMonth', subscription.period) }} x
                {{ $price(subscription.price / subscription.period) }})
              </span>
              <span class="card-subtext text-center">
                {{ tc('report.subscription.period.shortMonthSingular', subscription.period) }}
                {{ $t('report.subscription.notificationHint') }}
              </span>
              <BuyButton class="btn-default" @buy="buy(subscription)">
                {{ $t('buy') }}
              </BuyButton>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-slot:callToAction>
      <BuyMyMonitoring
        :product="product"
        :monitoringSettings="monitoringSettings"
        @buy="buy"
        class="d-none d-md-block"
      />
    </template>
    <template v-slot:default>
      <BuyMyMonitoring
        :product="product"
        :monitoringSettings="monitoringSettings"
        @buy="buy"
        class="d-md-none"
      />
      <BTabs nav-class="small-tabs d-print-none" content-class="structure-tabs">
        <BTab :title="$t('monitoring.events')">
          <div class="tab-container-medium">
            <Messages id="myMonitoring" />
            <NotificationSettings :userSettings="monitoringSettings" @update="updateMonitoringSettings" />
            <MyMonitoringEvents :product="product" ref="events" />
          </div>
        </BTab>
        <BTab :title="$t('monitoring.faq')" v-if="product.questions">
          <ExpandableList :items="product.questions" class="tab-container-medium" />
        </BTab>
      </BTabs>
    </template>
  </Report>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Report from './Report';
import BuyMyMonitoring from './BuyMyMonitoring';
import NotificationSettings from './MonitoringNotificationSettings';
import MyMonitoringEvents from './MyMonitoringEvents';
import ExpandableList from './ExpandableList';
import BuyButton from './BuyButton';
import Messages from './Messages';
import { BTab, BTabs } from 'bootstrap-vue-next';

export default {
  props: ['product'],
  components: {
    BTabs,
    BTab,
    Report,
    BuyMyMonitoring,
    MyMonitoringEvents,
    NotificationSettings,
    ExpandableList,
    BuyButton,
    Messages,
  },
  data: () => ({
    isSample: true,
  }),
  computed: {
    ...mapState('product', ['monitoringSettings']),
    ...mapGetters('session', ['isLoggedIn']),
    showDetails() {
      return !this.isLoggedIn || Object.keys(this.monitoringSettings).length > 0
        ? !this.monitoringSettings.isActive : false;
    },
  },
  methods: {
    ...mapActions('alerts', ['showMessage']),
    ...mapActions('purchase', ['clearCart']),
    ...mapActions('product', ['loadMyMonitoringSettings', 'updateMonitoringSettings']),

    tc(key, count) {
      return this.$t(key, count, { count });
    },

    buy(subscription) {
      const item = {};

      if (subscription) {
        item.subscriptionPeriod = subscription.period;
      }

      this.$emit('buy', item);
    },

    loadSettings() {
      if (this.isLoggedIn) {
        this.loadMyMonitoringSettings();
      }
    },
  },
  created() {
    if (this.$route.query.success) {
      this.showMessage({ target: 'myMonitoring', type: 'success', text: this.$t('purchase.successMonitoring') });
      this.$router.replace({ path: this.$route.path });
      this.clearCart();
    }

    this.loadSettings();
  },
  mounted() {
    this.$watch(() => this.$refs.events.isSample, (value) => this.isSample = value);
  },
};
</script>
